import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";

import {TransactionState} from "./types";

import TransactionService from "./transaction_services";

// Create a thunk to fetch transactions
export const fetchUserTransactions = createAsyncThunk(
    "transactions/fetchUserTransactions",
    async (_, {rejectWithValue}):Promise<any> => {
        try {
            // Make API request
            const data = await TransactionService.fetchUserTransactions();

            // Return response
            return data.data;
        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error?.response?.data?.message || error.message);
        }
    }
);


// Create a thunk to fetch a transaction
export const fetchUserTransaction = createAsyncThunk(
    "transactions/fetchUserTransaction",
    async (id: string, {rejectWithValue}) => {
        try {
            // Make API request
            const data = await TransactionService.fetchUserTransaction(id);

            // Return response
            return data.data;
        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error?.response?.data?.message || error.message);
        }
    }
);

// Create initial state
const initialState: TransactionState = {
    transactions: [],
    transaction: null,
    loading: false,
    error: null
}

// Create a slice
const transactionSlice = createSlice({
    name: "transactions",
    initialState,
    reducers: {
        clearTransaction: (state) => {
            state.transaction = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserTransactions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserTransactions.fulfilled, (state, action) => {
                state.loading = false;
                state.transactions = action.payload;
            })
            .addCase(fetchUserTransactions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(fetchUserTransaction.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserTransaction.fulfilled, (state, action) => {
                state.loading = false;
                state.transaction = action.payload;
            })
            .addCase(fetchUserTransaction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
    }
});

// Export actions
export const {clearTransaction} = transactionSlice.actions;

// Export reducer
export default transactionSlice.reducer;